import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Player from "./Player";
import { usePlayer } from "../../../hooks/usePlayer";

function AudioModal({ id, track, title, isVisible, onClose }) {
    const {
        isPlaying,
        setIsPlaying,
        duration,
        setDuration,
        currentTime,
        playerRef,
        progressBarRef,
        options,
        readyPlayer,
        handleStateChange,
        calculateTime,
        play,           // not used?
        togglePlayPause,
        stop,
        changeRange,
        backTen,
        forwardTen,
        timeTravel      // not used?
    } = usePlayer();

    return (
        <dialog id={id} className={`modal audio ${isVisible ? "visible" : ""}`}>
            <span className="close" onClick={() => { stop(); onClose(); }} aria-label="Close">
                <FontAwesomeIcon
                    icon="fa-solid fa-times"
                    className="icon"
                />
            </span>
            <p className="title"><em>{title}</em></p>
            <Player
                track={track}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
                duration={duration}
                setDuration={setDuration}
                currentTime={currentTime}
                playerRef={playerRef}
                progressBarRef={progressBarRef}
                options={options}
                readyPlayer={readyPlayer}
                handleStateChange={handleStateChange}
                calculateTime={calculateTime}
                play={play}                 // not used?
                togglePlayPause={togglePlayPause}
                stop={stop}
                changeRange={changeRange}
                backTen={backTen}
                forwardTen={forwardTen}
                timeTravel={timeTravel}     // not used?
            />
        </dialog>
    );
}

export default AudioModal;
